<template>
  <div class="register-view">
    <!-- Header Component -->
    <Header />
    
    <!-- Main Content Area -->
    <main class="main-content">
      <RegisterMask />
    </main>
    
    <!-- Footer Component -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import RegisterMask from '@/components/RegisterMask.vue';

export default {
  name: 'RegisterMaskView',
  components: {
    Header,
    RegisterMask,
    Footer
  }
};
</script>

<style scoped>
.register-view {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: linear-gradient(135deg, #ffffff 0%, #f2f5e7 100%);
}

.main-content {
  flex: 1;
  padding-top: 100px; /* Room for fixed header */
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 2rem;
}

@media (max-width: 768px) {
  .main-content {
    padding-top: 80px;
  }
}
</style>